<template>
  <v-container fluid id="toolOrders">
    <v-row wrap justify="center">
      <v-col cols="12" xs="12" class="headline pb-0">Tool Orders</v-col>
      <v-col cols="12" xs="12">
        <v-card>
          <v-tabs :value="activeTab" active-class="active-tab">
            <v-tab
              @click="
                orderType = 'toolOrdersOpen';
                activeTabUpdate(0);
              "
              >Open<span class="caption ml-1 grey--text"
                >({{ toolOrdersOpen.length }})</span
              ></v-tab
            >
            <v-tab
              @click="
                orderType = 'toolOrdersIncomplete';
                activeTabUpdate(1);
              "
              >Incomplete
              <span class="caption ml-1 grey--text"
                >({{ toolOrdersIncomplete.length }})</span
              ></v-tab
            >
            <v-tab
              @click="
                orderType = 'toolOrdersIssues';
                activeTabUpdate(2);
              "
              >Issues
              <span class="caption ml-1 grey--text"
                >({{ toolOrdersIssues.length }})</span
              ></v-tab
            >
            <v-tab
              @click="
                orderType = 'toolOrdersIssuesResolved';
                activeTabUpdate(3);
              "
              >Resolved Issues
              <span class="caption ml-1 grey--text"
                >({{ toolOrdersIssuesResolved.length }})</span
              ></v-tab
            >
            <v-tab
              @click="
                orderType = 'toolOrdersFulfilled';
                activeTabUpdate(4);
              "
              >All Fulfilled
              <span class="caption ml-1 grey--text"
                >({{ toolOrdersFulfilled.length }})</span
              ></v-tab
            >
            <v-tab
              @click="
                orderType = 'toolOrdersCancelled';
                activeTabUpdate(5);
              "
              >Cancelled
              <span class="caption ml-1 grey--text"
                >({{ toolOrdersCancelled.length }})</span
              ></v-tab
            >
          </v-tabs>
          <v-divider></v-divider>
          <tool-orders-table
            :toolOrders="currentToolOrders"
            :admin="true"
            :loading="loadingOrders"
            loading-text="Loading....please wait."
            :headers="headers"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import fb from "@/main";
import { mapState, mapGetters } from "vuex";
import ToolOrdersTable from "@/components/toolOrders/ToolOrdersTable";
export default {
  components: { ToolOrdersTable },
  data() {
    return {
      // currentToolOrders: [],
      orderType: "toolOrdersOpen",
      open: true,
      loadingOrders: true,
      headers: [
        {
          text: "Order",
          align: "left",
          value: "orderNumber",
        },
        {
          text: "Site Address",
          align: "left",
          value: "jobSite",
          sortable: false,
        },
        { text: "Ordered By", value: "fullName" },
        { text: "Fulfillment", value: "fulfilled" },
        { text: "", value: "fulfillmentDate", align: "left" },
        { text: "Request Date", value: "requestDay" },
        { text: "Order Date", value: "orderDate" },
        { text: "", value: "viewOrder", align: "right" },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "toolOrdersOpen",
      "toolOrdersFulfilled",
      "toolOrdersCancelled",
      "toolOrdersIncomplete",
      "toolOrdersIssues",
      "toolOrdersIssuesResolved",
    ]),
    ...mapState(["toolOrders", "closedToolOrders", "activeTab"]),
    currentToolOrders: function() {
      return this[this.orderType];
    },
  },
  async created() {
    try {
      if (!this.toolOrders.length) {
        await this.$store.dispatch("getToolOrders", fb);
      }
      if (this.activeTab == 0) {
        this.orderType = "toolOrdersOpen";
      } else if (this.activeTab == 1) {
        this.orderType = "toolOrdersIncomplete";
      } else if (this.activeTab == 2) {
        this.orderType = "toolOrdersIssues";
      } else if (this.activeTab == 3) {
        this.orderType = "toolOrdersIssuesResolved";
      } else if (this.activeTab == 4) {
        this.orderType = "toolOrdersFulfilled";
      } else if (this.activeTab == 5) {
        this.orderType = "toolOrdersCancelled";
      }
      this.loadingOrders = false;
    } catch (error) {
      console.log(error);
      alert("Error getting orders");
      this.loadingOrders = false;
    }
  },
  methods: {
    async getClosedOrders() {
      try {
        if (!this.closedToolOrders.length) {
          await this.$store.dispatch("getClosedToolOrders", fb);
        }
        this.orderType = "closedToolOrders";
        this.loadingOrders = false;
      } catch (err) {
        console.log(err);
        alert("Error getting orders");
        this.loadingOrders = false;
      }
    },
    activeTabUpdate(ix) {
      this.$store.commit("updateActiveTab", ix);
    },
  },
};
</script>

<style scoped>
.active-tab {
  background: whitesmoke;
}
</style>
